import React, { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { translations } from "./translations";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ValuePillars from "./components/ValuePillars";
import Development from "./components/Development";
import SitePlan from "./components/SitePlan";
import Amenities from "./components/Amenities";
import Standards from "./components/Standards";
import Nearshoring from "./components/Nearshoring";
import FinalCTA from "./components/FinalCTA";
import Contact from "./components/Contact";
import BuildToSuit from "./components/BuildToSuit";
import DocumentCenter from "./components/DocumentCenter";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

// Admin Components
import AdminLogin from "./admin/AdminLogin";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminContacts from "./admin/AdminContacts";
import AdminWarehouses from "./admin/AdminWarehouses";
import AdminLots from "./admin/AdminLots";
import AdminBuildToSuit from "./admin/AdminBuildToSuit";
import AdminDocuments from "./admin/AdminDocuments";
import AdminContent from "./admin/AdminContent";
import AdminSettings from "./admin/AdminSettings";

const HomePage = () => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('hexaparks_language') || 'en';
  });
  const [selectedLot, setSelectedLot] = useState(null);

  useEffect(() => {
    localStorage.setItem('hexaparks_language', language);
  }, [language]);

  const t = translations[language];

  const handleLotSelect = (lot) => {
    setSelectedLot(lot);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header t={t} language={language} setLanguage={setLanguage} />
      <Hero t={t} />
      <ValuePillars t={t} />
      <Development t={t} />
      {/* Park Interior Visual */}
      <section className="relative overflow-hidden">
        <img
          src="/images/renders/He_003.jpg"
          alt="Hexaparks park interior with warehouse units"
          className="w-full h-[260px] sm:h-[360px] lg:h-[450px] object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent opacity-80" />
      </section>
      <SitePlan t={t} language={language} onSelectLot={handleLotSelect} />
      <Amenities t={t} />
      <Standards t={t} />
      {/* Cinematic Visual Break */}
      <section className="relative overflow-hidden">
        <img
          src="/images/renders/HA02.jpeg"
          alt="Hexaparks warehouse street view"
          className="w-full h-[300px] sm:h-[400px] lg:h-[500px] object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-white via-transparent to-transparent h-24" />
      </section>
      <Nearshoring t={t} />
      <FinalCTA t={t} />
      <Contact t={t} language={language} selectedLot={selectedLot} />
      <BuildToSuit language={language} />
      <Footer t={t} />
      <WhatsAppButton language={language} />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/*" element={<AdminLayout />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="contacts" element={<AdminContacts />} />
            <Route path="lots" element={<AdminLots />} />
            <Route path="warehouses" element={<AdminWarehouses />} />
            <Route path="build-to-suit" element={<AdminBuildToSuit />} />
            <Route path="documents" element={<AdminDocuments />} />
            <Route path="content" element={<AdminContent />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>
          
          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
